"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSpellCheck = void 0;
function createSpellCheck(data) {
    return Object.freeze({
        originalQuery: data.originalQuery,
        correctedQuery: data.correctedQuery.value,
        type: data.type,
    });
}
exports.createSpellCheck = createSpellCheck;
